module.exports = __webpack_public_path__ + "img/img1.83e5005c.png";